import { IconTelephone, useBreakpointValue } from '@gazin/ecommerce-ui'
import Link from 'next/link'
import {  useEffect, useState } from 'react'
import { useBlackFriday } from 'src/contexto/hooks/useBlackFriday'
import { usePaymentMethod } from 'src/contexto/hooks/usePaymentMethod'
import { useWindowDimensions } from 'src/contexto/hooks/useWindowDimensions'
import NewsletterSection from '../newsletterSection'
import SacHorariosAtendimento from '../sacHorariosAtendimento'
import SetorInformacao from '../setorInformacao'
import {
  arePixOrBilletAvailable,
  getInCashAvailablePaymentMethods,
} from 'src/util/payment'
import { useGlobalContext } from 'src/contexto/contextoGlobal'
import { FooterSection, FooterContainer, SectionInfoPagamento } from './styles'
import AreaSecundaria from './areaSecundaria'

export default function Footer({
  showNewsletter = false,
  buttonColor = '',
  finalColor = '',
  initialColor = '',
  textColor = '',
}) {
  const [marginBottom, setMarginBottom] = useState(false)
  const { menuInstitucionalData, menuDuvidasData, sacInformation } =
    useGlobalContext()
  const { isBlackFridayTheme } = useBlackFriday()
  const { width } = useWindowDimensions()
  const { payment } = usePaymentMethod()

  useEffect(() => {
    definirMargemInferior()
  }, [])

  const isMobile = Boolean(
    useBreakpointValue({ base: true, sm: true, md: false })
  )

  function definirMargemInferior() {
    const barraFixa = document.querySelector('.barra-fixa')
    if (barraFixa) return setMarginBottom(true)
  }

  return (
    <>
      {showNewsletter && (
        <NewsletterSection
          initialColor={initialColor}
          finalColor={finalColor}
          background={true}
          buttonColor={buttonColor}
          textColor={textColor}
        />
      )}

      {isMobile && <SetorInformacao darkTheme={isBlackFridayTheme} />}

      <FooterSection id="footer" darkTheme={isBlackFridayTheme}>
        <FooterContainer marginBottom={marginBottom}>
          <div className="area-primaria">
            <div className="esq">
              <div className="atendimento">
                <IconTelephone width="2.3125rem" height="2rem" />
                <div className="info">
                  <span>Atendimento</span>
                  <a
                    href={`tel:${sacInformation?.telefone}`}
                    as={`tel:${sacInformation?.telefone}`}
                  >
                    {sacInformation?.telefone}
                  </a>
                  <SacHorariosAtendimento
                    horarioAtendimentoDiasUteisInicio={
                      sacInformation?.horario_atendimento_dias_uteis_inicio
                    }
                    horarioAtendimentoDiasUteisFim={
                      sacInformation?.horario_atendimento_dias_uteis_fim
                    }
                    horarioAtendimentoSabadoInicio={
                      sacInformation?.horario_atendimento_sabado_inicio
                    }
                    horarioAtendimentoSabadoFim={
                      sacInformation?.horario_atendimento_sabado_fim
                    }
                    horarioAtendimentoDomingoInicio={
                      sacInformation?.horario_atendimento_domingo_inicio
                    }
                    horarioAtendimentoDomingoFim={
                      sacInformation?.horario_atendimento_domingo_fim
                    }
                  ></SacHorariosAtendimento>
                </div>
              </div>
            </div>
            <nav>
              {menuInstitucionalData?.itens ? (
                <div className="item itemInstitucional">
                  <h3>Institucional</h3>
                  <ul>
                    {menuInstitucionalData?.itens.map((item) => {
                      return (
                        <li key={item.id}>
                          {item.parametros.target ? (
                            <a
                              href={item.parametros.url}
                              target={item.parametros.target}
                            >
                              {item.nome}
                            </a>
                          ) : (
                            <Link href={item.parametros.url}>{item.nome}</Link>
                          )}
                        </li>
                      )
                    })}
                  </ul>
                </div>
              ) : (
                ''
              )}
              {menuDuvidasData ? (
                <>
                  <div className="item itemDuvidas">
                    <h3>Dúvidas</h3>
                    <ul>
                      {menuDuvidasData?.itens?.map((item, key) => {
                        return key < 5 ? (
                          <li key={item.id}>
                            {item.chave_tipo === 'pagina' ? (
                              <Link
                                href="/pagina/[...pagina]"
                                as={`/pagina/${item.parametros.pagina_slug}`}
                                target={
                                  item.parametros.target
                                    ? item.parametros.target
                                    : ''
                                }
                              >
                                {item.nome}
                              </Link>
                            ) : (
                              <a
                                href={item.parametros.url}
                                target={
                                  item.parametros.target
                                    ? item.parametros.target
                                    : ''
                                }
                              >
                                {item.nome}
                              </a>
                            )}
                          </li>
                        ) : null
                      })}
                    </ul>
                  </div>

                  <div className="item itemDuvidasMenu">
                    <h3>&nbsp;</h3>
                    <ul>
                      {menuDuvidasData?.itens?.map((item, key) => {
                        return key >= 5 ? (
                          <li key={item.id}>
                            {item.chave_tipo === 'pagina' ? (
                              <Link
                                href="/pagina/[...pagina]"
                                as={`/pagina/${item.parametros.pagina_slug}`}
                                target={
                                  item.parametros.target
                                    ? item.parametros.target
                                    : ''
                                }
                              >
                                {item.nome}
                              </Link>
                            ) : (
                              <a
                                href={item.parametros.url}
                                target={
                                  item.parametros.target
                                    ? item.parametros.target
                                    : ''
                                }
                              >
                                {item.nome}
                              </a>
                            )}
                          </li>
                        ) : null
                      })}
                    </ul>
                  </div>
                </>
              ) : (
                ''
              )}
            </nav>
          </div>
          <AreaSecundaria />
        </FooterContainer>
      </FooterSection>
    </>
  )
}
